import { Card, Col as Cols, List, Row as Rows } from "antd";
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { invokeTrafficView } from "store/wheel/actions";
import { useNoiseMeter } from 'store/wheel/selectors';
import styled from 'styled-components';
import { CheckListImg, ClocksImg, DownArrowImg, birdLogoImg, newChats, newDebates, newIdeas } from "utils/assets/images";
import Expressions from 'utils/assets/images/Expressions.png';
import Image from 'utils/assets/images/Image.webp';
import NewGroup from 'utils/assets/images/New-Group.webp';
import NewStation from 'utils/assets/images/New-Station.webp';
import NoiseMeter from 'utils/assets/images/Noise-Meter.webp';
import Text from 'utils/assets/images/Text.webp';
import Timer from 'utils/assets/images/Timer.webp';
import Reminder from 'utils/assets/images/reminder.webp';
import TrafficSignal from 'utils/assets/images/Traffic Signal.webp';
import WheelImg1 from 'utils/assets/images/Wheel.webp';
import StoryImg from 'utils/assets/images/storyboard1.png';
import { useMobileDetect } from 'containers/chat/hooks';
import { Snackbar } from '@mui/material';
import { Alert } from '@mui/material';
import { openChat } from 'store/chatOpen/action';
import { useIdeaModal } from 'store/idea/selectors';
import { useDebateModal } from 'store/OneWayDebate/selectors';
import SentryWrap from 'components/Sentry';

const data = [
  {
    id: 1,
    title: 'Wheel',
    icons: WheelImg1,
    key: 'widget_wheel'
  },
  {
    id: 2,
    title: 'Noise Meter',
    icons: NoiseMeter,
    key: 'noise_meter'
  },
  {
    id: 3,
    title: 'Image',
    icons: Image,
    key: 'image'
  },
  {
    id: 4,
    title: 'Text',
    icons: Text,
    key: 'widget_text'
  },
  {
    id: 5,
    title: 'Traffic Signal',
    icons: TrafficSignal,
    key: 'traffic_signal'
  },
  {
    id: 6,
    title: 'Check List',
    icons: CheckListImg,
    key: 'widget_checklist'
  },
  {
    id: 7,
    title: 'Timer',
    icons: Timer,
    key: 'widget_timer'
  },
  {
    id: 8,
    title: 'Clock',
    icons: ClocksImg,
    key: 'widget_clock'
  },
  {
    id: 9,
    title: 'Expressions',
    icons: Expressions,
    key: 'widget_expressions'
  },
  {
    id: 10,
    title: 'New Station',
    icons: NewStation,
    key: 'new_station'
  },
  {
    id: 11,
    title: 'Reminder',
    icons: Reminder,
    key: 'widget_reminder'
  },
  {
    title: 'New Group',
    icons: NewGroup,
    key: 'new_group'
  },
  {
    title: '1Idea',
    icons: newIdeas,
    key: 'idea_withoneway'
  },
  {
    title: '1Debate',
    icons: newDebates,
    key: 'one_debate'
  },
  {
    title: 'Chat',
    icons: newChats,
    key: 'chat',
  },
];

const dataOnTab = [
    {
      id: 1,
      title: 'Wheel',
      icons: WheelImg1,
      key: 'widget_wheel'
    },
    {
      id: 2,
      title: 'Noise Meter',
      icons: NoiseMeter,
      key: 'noise_meter'
    },
    {
      id: 3,
      title: 'Image',
      icons: Image,
      key: 'image'
    },
    {
      id: 4,
      title: 'Text',
      icons: Text,
      key: 'widget_text'
    },
    {
      id: 5,
      title: 'Traffic Signal',
      icons: TrafficSignal,
      key: 'traffic_signal'
    },
    {
      id: 6,
      title: 'Check List',
      icons: CheckListImg,
      key: 'widget_checklist'
    },
    {
      id: 7,
      title: 'Timer',
      icons: Timer,
      key: 'widget_timer'
    },
    {
      id: 8,
      title: 'Clock',
      icons: ClocksImg,
      key: 'widget_clock'
    },
    {
      id: 9,
      title: 'Expressions',
      icons: Expressions,
      key: 'widget_expressions'
    },
    {
      id: 10,
      title: 'New Station',
      icons: NewStation,
      key: 'new_station'
    },
    {
      id: 11,
      title: 'Reminder',
      icons: Reminder,
      key: 'widget_reminder'
    },
    {
      title: 'New Group',
      icons: NewGroup,
      key: 'new_group'
    }
  ];

const BirdLogo = styled.img`
  height: 60px;
  margin-left: -10px;
  transition: transform 0.3s ease, opacity 0.3s ease;
//   opacity: 0;
`;

const DownArrow = styled.img`
  height: 13px;
  transition: transform 0.3s ease;
`;

// Wrapper to handle hover state
const HoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
//   padding: 13px 26px;
    max-height: 110px;
    width: 45px;
    border-radius: 23px;
    padding-top: 10px;
    padding-bottom: 10px;
    position: relative;
    // bottom: 6px;
    // right: 2px;  

// background-color: white;
//   border-radius: 30px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   flex-direction: column;
//   padding: 13px 26px;
//   min-height: 110px;
//   justify-content: space-between;
//   position: relative;
//   bottom: 6px;
//   right: -20px;
  

  &:hover ${BirdLogo} {
    transform: translateY(-10px);
    // opacity: 1;
    
  }
`;


const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    background-color: transparent;
`;
const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 100%;
    min-height: 100vh !important;
    // background-color: rgb(58,58,58);
    position: relative;
    justify-content: center;
    // padding-left: 20px;
    // padding-right: 20px;
    padding-top: 0px;

`;

const Row = styled.div`
    align-items: center;
    justify-content:center;
    display: flex;
    flex-direction: row;
    @media (max-width: 997px) {
         flex-direction: column;
         padding: 0px 30px;
   }
`;
const WheelWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background: transparent;
    z-index: 11;
    transition: all 1s ease 0s;
    cursor: pointer;
    // @media (max-width: 600px) {
    //     display:none;
    // }
`;

export default function WidgetsMenu({
  sharableWidget,
  tabletMode,
  widgetOpened,
  setIsWidgetOpened,
  checkingCanvasUser,
  trafficWidgetData
}) {
  const isMobile = useMobileDetect();
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobileDevice(window.innerWidth < 600);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const tabletWidget = widgetOpened;
  const {  viewIdeaModal } = useIdeaModal();
  const [debateModal, invokeDebateModal, revokeDebateModal] = useDebateModal();
  const dispatch = useDispatch();
  const [widgetsMenuModal, setWidgetsMenuModal] = useState(false)
  const [, invokeNoiseMeter] = useNoiseMeter()
  const [showWrapper, setShowWrapper] = useState(false);
  const [showOutAnimation, setShowOutAnimation] = useState(false);
  const [toast, setToast] = useState({
    value: false,
    message: ""
  });
  const toastTimeoutRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const storedPosition = JSON.parse(sessionStorage.getItem('currentPositionWidgets')) || { x: -30, y: -10 };
  // const [position, setPosition] = useState({ x: -30, y: -10 })
  const [position, setPosition] = useState(storedPosition)
  const [rel, setRel] = useState(null);
  const [isBirdHidden, setIsBirdHidden] = useState(false);

  const onWheelWrapperClick = async () => {
    if(dragging){
      return
    }
    if (isMobile && window.innerWidth < 600) {
      setToast({
        value: true, message: "Widget is not supported on mobile"
      })
      return;
    }
    setShowOutAnimation(true);
    setShowWrapper(true);
    await dispatch(openChat(false))
  };
  const handleCloseWidgets = () => {
    setShowOutAnimation(false);
    setTimeout(() => {
      setShowWrapper(false);
    }, 1000)
  }

  const onCloseWidgetsModal = () => {
    setWidgetsMenuModal(false)
  }

  const onWidgetClick = async (item) => {
    const widgetData = {
      id: item.id,
      view: true,
      menu: item.key
    }
    if (item?.key === 'traffic_signal') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'widget_clock') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'noise_meter') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'image') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'widget_timer') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'widget_reminder') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'widget_text') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'widget_wheel') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'widget_expressions') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'widget_checklist') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'widget_story') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'new_station') {
      await dispatch(invokeTrafficView(widgetData));
    } else if (item?.key === 'new_group') {
      await dispatch(invokeTrafficView(widgetData));
    }
  }


  const TabletWidgetWrapper = () => {
    return (
      <Wrapper
        className="spinWheelWrap"
      >
        <Container className="spinWheelCntnr">
          <div
            style={{
              width: "90%",
              position: "fixed",
              bottom: "6px !important",
              transform: "translate(-50 %, -50 %)",
              right: "4%",
            }}
            className={`allWidgetsContainer animate__animated`}
          >
            <Rows gutter={30} style={{ width: "100%" }}>
              <Cols sm={24} lg={24}>
                <div
                  className="widgetsMenuContainer"
                  style={{
                    backgroundColor: "white",
                    borderRadius: 55,
                    width: "100%",
                  }}
                >
                  <div className="allWidgetsSection">
                    <img
                      src={birdLogoImg}
                      style={{ height: 60, marginLeft: -10 }}
                    />
                    <div className="widgetsMidSEction">
                      <List
                        style={{
                          padding: "10px 20px",
                          overflowX: "auto",
                          flexWrap: "wrap",
                        }}
                        grid={{
                          gutter: 5,
                          column: 10,
                        }}
                        dataSource={dataOnTab}
                        renderItem={(item) => {
                          const isMatched = sharableWidget.some(sharedItem => sharedItem.widget_type === item.key);
                          const isFoundTraffic = trafficWidgetData.some(sharedItem => sharedItem.widget_type === item.key && sharedItem?.status === true);
                          const titleStyle = {
                            color: isMatched || isFoundTraffic  ? 'green' : 'black',
                            fontWeight: isMatched ? 'bold' : ''
                          };
                          return (
                          <List.Item
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              onWidgetClick(item);
                            }}
                          >
                            <Card title={<span style={titleStyle}>{item.title}</span>}>
                              {item?.Btn ? (
                                item?.Btn
                              ) : (
                                <img height="30px" src={item?.icons} />
                              )}
                            </Card>
                          </List.Item>
                        )}}
                      />
                    </div>
                    <img
                      src={DownArrowImg}
                      className="checkListCursor"
                      style={{ height: 13 }}
                      onClick={() => {
                         setIsWidgetOpened(false);
                        handleCloseWidgets()}}
                    />
                  </div>
                </div>
              </Cols>
            </Rows>
          </div>
        </Container>
      </Wrapper>
    );
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if (toastTimeoutRef.current) {
      clearTimeout(toastTimeoutRef.current);
    }
    setToast({ value: false, message: "" });
  }

  const handleAlertClose = () => {
    if (toastTimeoutRef.current) {
      clearTimeout(toastTimeoutRef.current);
    }
    setToast({ value: false, message: "" });
  }
  const onMouseMove = useCallback((e) => {
    if (!dragging) return;
  
    // Prevent default to stop scrolling only when dragging
    e.preventDefault();
  
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    
    const clientX = e.type.startsWith('touch') ? e.touches[0].pageX : e.pageX;
    const clientY = e.type.startsWith('touch') ? e.touches[0].pageY : e.pageY;
    
    let newX = clientX - rel.x;
    let newY = clientY - rel.y;
    if (newX > 0) newX = 0;
    if (newX < -windowWidth +  57) newX = -windowWidth + 57;
    if (newY > 0) newY = 0;
    if (newY < -windowHeight + 133) newY = -windowHeight + 133;
  
    setPosition({ x: newX, y: newY });
    sessionStorage.setItem('currentPositionWidgets', JSON.stringify({ x: newX, y: newY }));
  }, [dragging, rel]);

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      setPosition(prevPos => ({
        x: Math.max(Math.min(prevPos.x, 0), -windowWidth + 57),
        y: Math.max(Math.min(prevPos.y, 0), -windowHeight + 133)
      }));
      sessionStorage.setItem("currentPositionWidgets", JSON.stringify({
        x: Math.max(Math.min(position.x, 0), -windowWidth + 57),
        y: Math.max(Math.min(position.y, 0), -windowHeight + 133)
      }));
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const enableDragging = useCallback((e) => {
    if (e.button !== 0 && e.type !== 'touchstart') return;
  
    // Prevent default to stop scrolling on touch devices
    e.preventDefault();
  
    setDragging(true);
    setRel({
      x: (e.type.startsWith('touch') ? e.touches[0].pageX : e.pageX) - position.x,
      y: (e.type.startsWith('touch') ? e.touches[0].pageY : e.pageY) - position.y,
    });
  }, [position]);
  
  // const disableDragging = useCallback(() => {
  //   e.stopPropagation();
  //   e.preventDefault();
  // }, [position.x, position.y]);

  const disableDragging = useCallback(() => {
    setDragging(false);
  }, []);

  useEffect(() => {
    const showWrapperHandler = () => {
      if(!tabletMode){
        setShowWrapper(false);
      }
      
    };

    showWrapperHandler(); 
    window.addEventListener('resize', showWrapperHandler);

    return () => {
      window.removeEventListener('resize', showWrapperHandler); 
    };
  }, [tabletMode]);
  
  useEffect(() => {
    if (toast.value) {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }
      toastTimeoutRef.current = setTimeout(() => {
        setToast({ value: false, message: "" });
      }, 3000);
    }
    return () => {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }
    };
  }, [toast.value, window.innerWidth]);

  useEffect(() => {
    if (dragging) {
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', disableDragging);
      document.addEventListener('touchmove', onMouseMove, { passive: false });
      document.addEventListener('touchend', disableDragging);
    } else {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', disableDragging);
      document.removeEventListener('touchmove', onMouseMove);
      document.removeEventListener('touchend', disableDragging);
    }
  
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', disableDragging);
      document.removeEventListener('touchmove', onMouseMove);
      document.removeEventListener('touchend', disableDragging);
    };
  }, [dragging, onMouseMove, disableDragging]);

  return (<SentryWrap>
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={toast?.value}
      onClose={handleClose}
    >
      <Alert onClose={handleAlertClose} severity="error">
        <strong>ALERT:</strong> {toast.message}
      </Alert>
    </Snackbar>
    {widgetOpened && tabletMode  && <TabletWidgetWrapper />}
    {!isMobileDevice && (!showWrapper ? (
      <div>
        <div
          style={{
            position: 'fixed',
            right: 0,
            bottom: 0,
            transform: 'translateY(-50%)',
            width: 20,
            height: 44,
            backgroundColor: '#fff',
            borderTopLeftRadius: 9,
            borderBottomLeftRadius: 9,
            display: checkingCanvasUser
              ? 'flex'
              : tabletMode
                ? 'none'
                : 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 10px',
            zIndex: 999,
            cursor: 'pointer',
          }}
          onClick={(e) => {
            e.stopPropagation();
            setIsBirdHidden((prev) => !prev);
          }}
          onTouchStart={(e) => {
            e.stopPropagation();
            setIsBirdHidden((prev) => !prev);
          }}
        >
          <span style={{ fontSize: 40, lineHeight: 1, color: '#51331a', display: 'inline-block', paddingBottom: 6 }}>
            {isBirdHidden ? '‹' : '›'}
          </span>
        </div>
        <WheelWrapper
          // style={{ display:  tabletMode && "none", width: "55px" }}
          style={{
            display: checkingCanvasUser
              ? 'flex'
              : tabletMode
                ? 'none'
                : 'inherit',
            width: '55px',
            pointerEvents: isBirdHidden ? 'none' : 'auto',
          }}
    onClick={() => onWheelWrapperClick()}
    onTouchStartCapture={() => onWheelWrapperClick()}
    className='wheelSpinImg wheel-spin-image'
  >
    <Cols sm={24} lg={2} style={{ alignItems: 'center' }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 30,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '20px 31px',
        minHeight: 110,
        justifyContent: 'space-between',
        position: 'relative',
        bottom: 6,
        right: isBirdHidden ? -120 : 30,
        opacity: isBirdHidden ? 0 : 1,
        transition: 'right 0.25s ease, opacity 0.2s ease',
        // top: position.y + "px",
        // left: position.x + "px",
        boxShadow: 'rgba(0, 0, 0, 0.19) -6px -12px 23px, rgba(0, 0, 0, 0.23) -5px 20px 20px'
      }}
      onMouseDown={enableDragging}
      onTouchStart={enableDragging} // Add touchstart handler
      className="bird-container tabs-widgets">
        <HoverWrapper>
          <BirdLogo className='bird-logo-widget image-select-none' src={birdLogoImg} />
          <DownArrow className='down-arrow-widget' src={DownArrowImg} />
        </HoverWrapper>
      </div>
    </Cols>
        </WheelWrapper>
      </div>
    ) : (
      <Wrapper className='spinWheelWrap' onClick={() => setWidgetsMenuModal(true)}>
        <Container className='spinWheelCntnr'>
          <div style={{ width: '90%', position: 'fixed', bottom: '6px', transform: 'translate(-50 %, -50 %)', right: '4%' }} className={`allWidgetsContainer animate__animated ${showOutAnimation ? 'animate__bounceInUp' : 'animate__bounceOutDown'}`}>
            <Rows gutter={30} style={{ width: '100%' }}>
              <Cols sm={24} lg={24}>
                <div className='widgetsMenuContainer' style={{ backgroundColor: 'white', borderRadius: 55, width: '100%', }}>
                  <div className='allWidgetsSection'>
                    <img src={birdLogoImg} style={{ height: 60, marginLeft: -10 }} />
                    <div className='widgetsMidSEction'>
                      <List
                        style={{ padding: '10px 20px', overflowX: 'auto', flexWrap: 'wrap' }}
                        grid={{
                          gutter: 5,
                          column: 10,
                        }}
                        dataSource={data}
                        renderItem={(item) => {
                          const isMatched = sharableWidget.some(sharedItem => sharedItem.widget_type === item.key);
                          const isFoundTraffic = trafficWidgetData.some(sharedItem => sharedItem.widget_type === item.key && sharedItem?.status === true);
                          const titleStyle = {
                            color: isMatched || isFoundTraffic  ? 'green' : 'black',
                            fontWeight: isMatched ? 'bold' : ''
                          };
                          return (
                          <List.Item style={{ cursor: 'pointer' }} onClick={async () => {
                            onWidgetClick(item)
                            if (item.key === 'chat') {
                              setShowWrapper(false);
                              await dispatch(openChat(true))
                            } else if (item.key === 'idea_withoneway') {
                              viewIdeaModal()
                            } else if (item.key === 'one_debate') {
                              invokeDebateModal();
                            }
                          }}>
                            <Card title={<span style={titleStyle}>{item.title}</span>}>{item?.Btn ? item?.Btn : <img height="30px" src={item?.icons} />}</Card>
                          </List.Item>
                        )}}
                      />
                    </div>
                    <img src={DownArrowImg} className="checkListCursor" style={{ height: 13 }} onClick={() => handleCloseWidgets()} />
                  </div>
                </div>
              </Cols>
            </Rows>
          </div>
        </Container>
      </Wrapper>
      ))}
  </SentryWrap>)
}
